import { render, staticRenderFns } from "./Add-terminal.vue?vue&type=template&id=5ee20987&scoped=true"
import script from "./Add-terminal.vue?vue&type=script&lang=js"
export * from "./Add-terminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee20987",
  null
  
)

export default component.exports